import axios from 'axios';
import { cookies, deleteTokenFromCookie } from './vue-cookies';
import { errorMessage } from './element-ui';
import { YorkbbsSign } from '@/utils/signature';
import { responseErrorFormat,hostBuild } from '@/utils/utils';
import FingerprintJS from '@fingerprintjs/fingerprintjs'

// 签名不通过，排查 NaN ，axios 会把 NaN 转换成 null
export function getAxios(appId, appKey) {
  let visitorId =  (async()=>{
    const fp = await FingerprintJS.load();
    const result = await fp.get();
    const resultId = await result.visitorId;
    
  
    return resultId;
  })(); 
  axios.interceptors.request.use(
    async config => {
      let uuid = await visitorId;
      if (config.method == 'get') {
        const token = cookies.get('token');
        if (token) {
          config.headers['token'] = token ? token : '';
        }
        return config;

      };

      /* 签名 */
      const { timestamp, nonceStr, sign } = new YorkbbsSign(appKey, { ...config.data },uuid).getSignData();

      config.headers['timestamp'] = timestamp;
      config.headers['nonce-str'] = nonceStr;
      config.headers['sign'] = sign;
      config.headers['appid'] = appId;
      config.headers['client'] = 'pc';
      config.headers['uuid'] = uuid;
      const token = cookies.get('token');
      if (token) {
        config.headers['token'] = token ? token : '';
      }
      return config;
    },
    error => Promise.reject(error),
  );

  axios.interceptors.response.use(
    res => {
      const { code, msg } = res.data;
      if (code === -1) {
        errorMessage(msg);
        return Promise.reject(msg);
      } else if (code === -2) {
        errorMessage(msg);
        return Promise.resolve(msg);
      } else if(code == -3){
        
        window.location.replace('/404?from='+encodeURIComponent(window.location.href));
        
        return Promise.reject(msg);
      } else if (code === 1) {
        // 需要重新登录
        deleteTokenFromCookie();
  
        return res.data;
      } else if (code === 2) {
        // 无权限
        errorMessage(msg);
        return Promise.reject(msg);
      } else {
        return res.data;
      }
    },
    err => {
      console.log(err.response);
      let e;

      // GateWay 超时
      if (err.response.status == 504) {
        errorMessage((e = responseErrorFormat(err.config.url, err.response.status, err.response.statusText)));
      } else if (err.response.data.msg) {
        errorMessage((e = responseErrorFormat(err.config.url, err.response.status, err.response.data.msg)));
      } else {
        errorMessage((e = responseErrorFormat(err.config.url, err.response.status, err.response.data)));
      }

      throw new Error(e);
    },
  );

  return axios;
}
